"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.privateRouter = exports.publicRouter = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const schemas = __importStar(require("../schemas"));
const c = (0, core_1.initContract)();
const pathPrefix = '/workspaces';
const publicRoutes = c.router({
    getWorkspace: {
        method: 'GET',
        path: '/:id',
        pathParams: zod_1.z.object({
            id: schemas.Uuid,
        }),
        responses: { 200: schemas.GetWorkspaceResponse },
    },
});
const privateRoutes = c.router({
    searchDocuments: {
        method: 'POST',
        path: '/:id/search',
        pathParams: zod_1.z.object({
            id: schemas.Uuid,
        }),
        body: schemas.SearchRequest,
        responses: {
            200: schemas.SearchResponse,
        },
    },
    create: {
        method: 'POST',
        path: '/',
        body: zod_1.z.object({
            name: zod_1.z.string(),
            templateCode: zod_1.z.string(),
        }),
        responses: {
            201: zod_1.z.object({
                id: schemas.Uuid,
            }),
        },
    },
    getTemplates: {
        method: 'GET',
        path: '/templates',
        responses: {
            200: zod_1.z.object({
                templates: zod_1.z.array(schemas.TemplateWorkspaceListing),
            }),
        },
    },
    getArchivedScript: {
        method: 'GET',
        path: '/:id/archive/:scriptId',
        pathParams: zod_1.z.object({
            id: schemas.Uuid,
            scriptId: zod_1.z.string(),
        }),
        responses: {
            200: schemas.ClassicScriptSchema,
        },
    },
    retire: {
        method: 'PUT',
        path: '/:id/retire',
        pathParams: zod_1.z.object({
            id: schemas.Uuid,
        }),
        body: schemas.EmptyBody,
        responses: Object.assign({ 200: schemas.SuccessResponse }, schemas.ScrapiErrorMessage),
    },
});
const allRoutes = Object.assign(Object.assign({}, privateRoutes), publicRoutes);
exports.publicRouter = c.router(publicRoutes, { pathPrefix });
exports.privateRouter = c.router(allRoutes, { pathPrefix });
